import React, {useEffect, useState} from 'react';
import {
    checkInPeriodsActions,
    contingentsActions,
    locationActions,
    priceTariffsActions,
    useSelector
} from "inbooma-api";
import t from '../../../helpers/t';
import {Biscuit} from "../../../../utils";
import Dialog from "@material-ui/core/Dialog";
import DatePicker from "react-datepicker";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";
import {$, moment} from "../../../../../vendor";
import Loader from "../../../components/Loader";
import {dateFormat} from "../../../../utils/FormatHelper";

const AvailabilitiesView = (props) => {
    const { dispatch, returnUrl, params } = props;
    const [filter, setFilter] = useState({
        type: 'day',
        from: moment().format('YYYY-MM-DD HH:mm'),
        client_id: Biscuit.get('user.client_id')
    });
    const language = Biscuit.get('user.lang').replace('-','_');
    const _availableTimes = useSelector(state => state.check_in_periods_data.getAvailableTimes);
    const _pricetariffs = useSelector(state => state.price_tariffs_data.pricetariffs);
    const _contingents = useSelector(state => state.contingents_data.contingents);
    const _locations = useSelector(state => state.locations_data.locations);
    const [availableTimesDay, setAvailableTimesDay] = useState(null);
    const [availableTimesWeek, setAvailableTimesWeek] = useState(null);
    const [availableTimesEndWeek, setAvailableTimesEndWeek] = useState(null);
    const [pricetariffs, setPricetariffs] = useState([]);
    const [contingents, setContingents] = useState([]);
    const [locations, setLocations] = useState([]);
    const [availableTimesPending, setAvailableTimesPending] = useState(false);
    const [availableTimesEndPending, setAvailableTimesEndPending] = useState(false);
    const [availablesEnd, setAvailablesEnd] = useState(false);
    const [start, setStart] = useState(moment().format('YYYY-MM-DD HH:mm'));
    const [selectedTime, setSelectedTime] = useState(null);
    const [pricetariffsPending, setPricetariffsPending] = useState(false);
    const [contingentsPending, setContingentsPending] = useState(false);
    const [locationsPending, setLocationsPending] = useState(false);
    const [timesPending, setTimesPending] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [times, setTimes] = useState(null);
    const [endTimes, setEndTimes] = useState(null);
    const [selectedType, setSelectedType] = useState('day');
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedContingent, setSelectedContingent] = useState(null);
    const [selectedPricetariff, setSelectedPricetariff] = useState(null);

    const types = [
        {key: 'day', label: t('erste Verfügbarkeit pro Station')}, {key: 'week', label: t('Verfügbare Zeiten pro Woche')}, {key: 'month', label: "Verfügbarkeit Monatskalender"}
    ];
    let availDates= {};
    const [firstTime, setFirstTime] = useState(true);

    const reset = () =>
    {
        setAvailableTimesDay(null);
        setAvailableTimesWeek(null);
        setAvailableTimesEndWeek(null);
    }
    useEffect(() => {
        if(initialized || availableTimesPending || pricetariffsPending || contingentsPending || locationsPending){
            return;
        }
        dispatch(checkInPeriodsActions.getAvailableTimes({
            token: Biscuit.get('token'),
            body: filter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setAvailableTimesPending(true);
        dispatch(priceTariffsActions.getPricetariffs({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setPricetariffsPending(true);
        dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                'findForSelect': true,
                'limit': 1000
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setLocationsPending(true);
        dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            filter: {
                'findForSelect': true,
                'limit': 1000
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setContingentsPending(true);
    },[]);

    const setAllTimes = (data) => {
        let ts = 'day';
        let f = 0;
        Object.keys(data).map(date => {
            if(Array.isArray(data[date])) {
                ts = 'week';
                data[date].map(tm => {
                    let ke = null;
                    Object.keys(tm).map(tr => {
                        if (tm[tr] === 'active') {
                            ke = tr;
                            f++;
                        }
                    })
                    if(f===1 && firstTime && ts === 'week'){
                        console.log(date+' '+ke);
                        setSelectedTime(date+' '+ke);
                    }
                    availDates[date] = (ke !== null);

                })
            } else {

                if(typeof data[date].available !== 'undefined'){
                    ts = 'day';
                    let set = data[date].available;
                    if(!set && data[date].time !== null){
                        set = true;
                    }
                    availDates[date] = set;
                }

            }
        });
        setTimesPending(true);
        if(!availablesEnd) {
            setTimes(availDates);
        } else {
            setEndTimes(availDates);
        }
        switch(ts){
            case 'day':
                setAvailableTimesDay(data);
                break;
            case 'week':
                if(availablesEnd){
                    setAvailableTimesEndWeek(data);
                } else {
                    setAvailableTimesWeek(data);
                }
                break;
        }
    }

    useEffect(() => {
        if(_availableTimes.success === '' || (!availableTimesPending && !availableTimesEndPending)){
            return;
        }
        if(_availableTimes.success === true){
            setAllTimes(_availableTimes.data);
        }
        setAvailableTimesPending(false);
        setAvailableTimesEndPending(false);
        if(!contingentsPending && !locationsPending && !pricetariffsPending){
            setInitialized(true);
        }
    },[_availableTimes]);


    useEffect(()=> {
        if(!timesPending || (times === null && endTimes === null)){
            return;
        }
        setTimesPending(false);
    },[times, endTimes])

    useEffect(() => {
        if(_pricetariffs.success === '' || !availableTimesPending){
            return;
        }
        if(_pricetariffs.success === true){
            setPricetariffs(_pricetariffs.data);
        }
        setPricetariffsPending(false);
        if(!contingentsPending && ! locationsPending && !pricetariffsPending){
            setInitialized(true);
        }
    },[_pricetariffs]);

    useEffect(() => {
        if(_locations.success === '' || !locationsPending){
            return;
        }
        if(_locations.success === true){
            setLocations(_locations.data);
        }
        setLocationsPending(false);
        if(!contingentsPending && ! availableTimesPending && !pricetariffsPending){
            setInitialized(true);
        }
    },[_locations]);

    useEffect(() => {
        if(_contingents.success === '' || !contingentsPending){
            return;
        }
        if(_contingents.success === true){
            setContingents(_contingents.data);
        }
        setContingentsPending(false);
        if(!availableTimesPending && ! locationsPending && !pricetariffsPending){
            setInitialized(true);
        }
    },[_contingents]);


    const currentUrl = new URL(window.location.href);
    const handleCloseDialog = () => {
        let returns = '/';
        window.location.replace(returns);
    }

    const renewAvailableTimes = (locationId = null, contingentId = null, pricetariffId = null, type = null, time = null, end = false) => {
        let l = (locationId !== null?locationId:selectedLocation);
        let c = (contingentId !== null?contingentId:selectedContingent);
        let p = (pricetariffId !== null?pricetariffId:selectedPricetariff);
        let ts = (time !==null?time:selectedTime);
        let e = (end?end:availablesEnd);
        if(availableTimesPending || availableTimesEndPending || (selectedType === 'week' && (typeof l === 'undefined' || l === null || typeof c === 'undefined' || c === null || typeof p === 'undefined' || p === null))){
            return;
        }
        let t = (type !== null?type:selectedType);
        dispatch(checkInPeriodsActions.getAvailableTimesResetData());
        let payload = {
            client_id: Biscuit.get('user.client_id'),
            from: start,
            type: t
        };
        switch(t){
            case 'day':
                setAvailableTimesDay(null);
                break;
            case "week":
                if(e){
                    setAvailableTimesEndWeek(null);
                } else {
                    setAvailableTimesWeek(null);
                }
                payload.type = 'week';
                payload.location_id = locationId !== null?locationId:selectedLocation;
                payload.contingent_id = contingentId !== null?contingentId:selectedContingent;
                payload.pricetariff_id = pricetariffId !== null?pricetariffId:selectedPricetariff;
                if(e){
                    payload.end = ts;
                }
                break;
            case 'month':
                payload.location_id = locationId !== null?locationId:selectedLocation;
                break;
        }

        dispatch(checkInPeriodsActions.getAvailableTimes({
            token: Biscuit.get('token'),
            body: payload,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        if(e){
            setAvailableTimesEndPending(true);
        } else {
            setAvailableTimesPending(true);
        }
    }

    const onChangeField = (e,name) => {
        let l = null, c= null, p = null;
        let t = selectedType;
        switch (name){
            case "start_field":
                let date = moment(e).format('YYYY-MM-DD 00:00:00');
                setStart(date);
                break;
            case "type_field":
                setSelectedType(e.target.value);
                t = e.target.value;
                reset();
                break;
            case "location_field":
                if(e.target.value !== null) {
                    setSelectedLocation(Number(e.target.value));
                    l = Number(e.target.value);
                } else {
                    setSelectedLocation(null);
                }
                break;
            case "contingent_field":
                if(e.target.value !== null) {
                    setSelectedContingent(Number(e.target.value));
                    c = Number(e.target.value);
                } else {
                    setSelectedContingent(null);
                }
                break;
            case "pricetariff_field":
                if(e.target.value !== null) {
                    setSelectedPricetariff(Number(e.target.value));
                    p = Number(e.target.value);
                }else {
                    setSelectedPricetariff(null);
                }
                break;
        }
        renewAvailableTimes(l,c,p,t, selectedTime, false);
    }

    const onDateTimeSelect = (time,date, withoutSet = false) => {
        /*if(selectedTime === moment(new Date(date+' '+time)).format('DD.MM.YYYY HH:mm') || availableTimesEndPending){
            return;
        }*/
        setAvailablesEnd(true);
        if(!withoutSet) {
            setSelectedTime(moment(new Date(date + ' ' + time)).format('DD.MM.YYYY HH:mm'));
        }
        renewAvailableTimes(selectedLocation,selectedContingent,selectedPricetariff,'week',date+' '+time, true);
    }

    const renderSwitch = (end = false) => {

        switch(selectedType) {
            case 'day':
                return (<>
                    {times !== null && locations.map(location => {
                        let show = "";
                        if (typeof availableTimesDay[location.id] !== 'undefined') {
                            if (new Date(availableTimesDay[location.id].time) > new Date(moment(new Date()).add(3, 'm'))) {
                                show = moment(availableTimesDay[location.id].time).format(dateFormat(language, true, true));
                            }
                            return (<>
                                <div className="row">
                                    <div className="column medium-6 small-12" style={!times[location.id]?{color:'red'}:{}}>
                                        {location.name} ({location.id})
                                    </div>
                                    <div className="column medium-6 small-12">
                                        {show}
                                    </div>
                                </div>
                            </>);
                        } else{
                            return(<> <div className="row">
                                <div className="column medium-12 small-12"> Kein Eintrag für {location.name} ({location.id})</div></div></>)
                        }
                    })}
                </>);
            case 'week':
                if(!timesPending) {
                    if(end){
                        return (<>
                            {!availableTimesEndPending && endTimes !== {} && <>
                                <div className="row">
                                    <div className="column medium-12"><h4>Ende</h4>
                                    </div>
                                </div>
                                <div className="row">
                                    {Object.keys(availableTimesEndWeek).map(date => {
                                        return (
                                            <>
                                                <div className="column medium-1" style={{minWidth: "14%"}}>
                                                    <span
                                                        className={(typeof endTimes[date] !== 'undefined' && endTimes[date] ? 'greenDot' : '')}>{date}</span>
                                                    <br/>
                                                    <select>

                                                        {Array.isArray(availableTimesEndWeek[date]) && availableTimesEndWeek[date].map(tm => {
                                                            let disabled = false;
                                                            let ke = null;
                                                            Object.keys(tm).map(tr => {
                                                                ke = tr;
                                                                if (tm[tr] !== 'active') {
                                                                    disabled = true;
                                                                }
                                                            })

                                                            /* let clone = {};
                                                             Object.assign(clone,times);
                                                             clone[date] = (ke !== null)
                                                             setTimes(clone);*/

                                                            return (<>
                                                                {ke !== null && <option value={ke}
                                                                                        disabled={disabled}>{ke}</option>}
                                                            </>);
                                                        })}
                                                    </select>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </>}
                        </>);

                    }else {
                        if (!availableTimesPending && availableTimesWeek === null) {
                            renewAvailableTimes();
                            if (selectedPricetariff === null || selectedLocation === null || selectedContingent === null) {
                                return (<>
                                    <div className="row">
                                        <div className="column medium-12"><span>Preistariff, Kontingent und Standort muss gesetzt sein</span>
                                        </div>
                                    </div>
                                </>)
                            }
                        } else {
                            let sel = start;
                            if(firstTime && !availableTimesPending && times !== {}){
                                 setFirstTime(false);
                                 let tem = sel.split(' ');
                                onDateTimeSelect(tem[1],tem[0], true);
                            }
                            return (<>
                                {!availableTimesPending && times !== {} && <>
                                    <div className="row">
                                        <div className="column medium-12"><h4>Beginn</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {Object.keys(availableTimesWeek).map(date => {
                                            if(selectedTime !== null){
                                                let temp = selectedTime.split(' ');
                                                if(moment(new Date(temp[0])).format('YYYY-MM-DD') === date){
                                                    sel=temp[1];
                                                }
                                            }
                                            return (
                                                <>
                                                    <div className="column medium-1" style={{minWidth: "14%"}}>
                                                    <span
                                                        className={(typeof times[date] !== 'undefined' && times[date] ? 'greenDot' : '')}>{date}</span>
                                                        <br/>
                                                        <select onChange={e => onDateTimeSelect(e.target.value,date)} defaultValue={sel}>

                                                            {Array.isArray(availableTimesWeek[date]) && availableTimesWeek[date].map(tm => {
                                                                let disabled = false;
                                                                let ke = null;
                                                                Object.keys(tm).map(tr => {
                                                                    ke = tr;
                                                                    if (tm[tr] !== 'active') {
                                                                        disabled = true;
                                                                    }
                                                                })

                                                                /* let clone = {};
                                                                 Object.assign(clone,times);
                                                                 clone[date] = (ke !== null)
                                                                 setTimes(clone);*/

                                                                return (<>
                                                                    {ke !== null && <option value={ke}
                                                                                            disabled={disabled}>{ke}</option>}
                                                                </>);
                                                            })}
                                                        </select>
                                                    </div>
                                                </>
                                            )
                                        })}
                                    </div>
                                </>}
                            </>);
                        }
                    }
                }
                break;
            case 'month':
                return (<>  </>);
            default:
                return (<>  </>);
        }
    }

    return (<>
        {initialized &&
            <>
                <Dialog
                    onClose={handleCloseDialog}
                    aria-labelledby="changelogs-dialog-title"
                    open={true}
                    name="changeLogsDialog"
                    id="multipleRecipientsDialog"
                    maxWidth={"md"}
                >
                    <header className="inb-multiple-recipients-header">

                        <button
                            onClick={handleCloseDialog}
                            type="button"
                            id="inb-multiple-recipients-dialog-close-button"
                            className="button hollow secondary right button-close-multiple-recipients-dialog round"
                            title={t("close generate new pin dialog")}
                        >
                            <i className="fi fi-x"></i>
                        </button>
                        <h4>{t('Available Times Test', null, 'capital')}</h4>

                        {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}

                    </header>
                    {/*<div id="inb-c-main-multiple-recipients" className="inb-c-listing off-canvas-content"
                     data-off-canvas-content="">
                    {!boxTrackingsPending && typeof _boxTrackings.data !== 'undefined' && _boxTrackings?.data?.length > 0 ? _boxTrackings.data.map(boxTracking => {
                        return (<>
                            <div className="inb-c-item inb-c-item--recipient row" key={boxTracking.id}>
                                <div className="medium-3 small-12 column" title={t('id', null, 'capital')}
                                     style={{minWidth: '90px'}}>
                                    <span>{moment(boxTracking.created).format('DD.MM.YY HH:mm')}</span>
                                </div>
                                <div className="medium-3 small-12 column username"
                                     title={t('recipient', null, 'capital')}
                                     style={{minWidth: '90px', cursor: 'pointer'}}>
                                    <a href={`/users/${boxTracking.user_id}?path=/facilities`}><span>{getUserNameById(boxTracking.user_id)}</span></a>
                                </div>
                                <div className="medium-6 small-12 column description"
                                     title={t('profile', null, 'capital')} style={{minWidth: '90px'}}>
                                    <span>{boxTracking.description}</span>
                                </div>
                            </div>
                        </>)
                    }): <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement">
                        <div className="inb-image-box">
                            <img src="assets/img/no_data.svg"/>
                        </div>
                        <h3>
                            { t('app_msg_collection_empty') }
                        </h3>
                        <p>
                            { t('app_msg_collection_empty_body') }
                        </p>
                    </div>
                </>}*/}

                    {/*</div>*/}
                    <div id="inb-c-main-available-times" className="inb-c-listing off-canvas-content" data-off-canvas-content="">
                        <div className="inb-c-item inb-c-item--from row" key='from'>
                            <div className="small-6 column">
                                <div className="input-group inb-price-input-group">
                                    <div className="float-left">
                                        <label>{t('Datum')}</label>
                                        <DatePicker
                                            key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                                            className="input-group-field"
                                            dateFormat='dd. MMMM y'
                                            selected={new Date(start)}
                                            onChange={date => onChangeField(date,"start_field")}
                                            onKeyDown={e => {
                                                if (e.keyCode === 8) e.preventDefault();
                                            }}
                                            placeholderText=""
                                            locale={Biscuit.get('user.lang').indexOf('de') >= 0 ? de : (Biscuit.get('user.lang').indexOf('fr') >= 0 ? fr : en)}
                                        />
                                    </div>
                                 {/*   <input
                                        className="input-group-field"
                                        type="time"
                                        name="from_time_field"
                                        value={moment(new Date(from)).format('HH:mm') }
                                        style={{maxWidth: "40%"}}
                                        onChange={(e)=>{onChangeField(e,"from_time_field")}}
                                    />*/}

                                </div>
                            </div>
                            <div className="small-6 column">
                                <div className="input-group inb-price-input-group">
                                    <div className="float-left">
                                        <label>{t('Typ')}</label>
                                       <select onChange={(e)=>{onChangeField(e,"type_field")}} defaultValue={selectedType}>
                                           {types.map(type => {
                                                return (
                                                    <>
                                                        <option value={type.key} disabled={(type.key === 'month')}>{type.label}</option>
                                                    </>
                                                )
                                           })}
                                       </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {selectedType === 'week' && <>
                        <div className="inb-c-item inb-c-item--from row" key='lo'>
                        {!locationsPending &&
                            <>
                            <div className="small-6 column">
                                <div className="input-group inb-price-input-group">
                                    <div className="float-left">
                                        <label>{t('Standort')}</label>
                                        <select defaultValue={selectedLocation} onChange={(e)=>{onChangeField(e,"location_field")}}>
                                            <option value={null}>{t('switch')}</option>
                                            {locations.map(location => {
                                              return (<>
                                              <option value={location.id}>{location.name}</option>
                                              </>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            </>}
                            {!contingentsPending &&
                                <>
                                    <div className="small-6 column">
                                        <div className="input-group inb-price-input-group">
                                            <div className="float-left">
                                                <label>{t('Kontingent')}</label>
                                                <select defaultValue={selectedContingent} onChange={(e)=>{onChangeField(e,"contingent_field")}}>
                                                    <option value={null}>{t('switch')}</option>
                                                    {contingents.map(contingent => {
                                                        return (<>
                                                            <option value={contingent.id}>{contingent.name}</option>
                                                        </>)
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="inb-c-item inb-c-item--from row" key='pr'>
                                {!pricetariffsPending &&
                                    <>
                                        <div className="small-6 column">
                                            <div className="input-group inb-price-input-group">
                                                <div className="float-left">
                                                    <label>{t('Preistarif')}</label>
                                                    <select defaultValue={selectedPricetariff} onChange={(e)=>{onChangeField(e,"pricetariff_field")}}>
                                                        <option value={null}>{t('switch')}</option>
                                                        {pricetariffs.map(pricetariff => {
                                                            return (<>
                                                                <option value={pricetariff.id}>{pricetariff.name}</option>
                                                            </>)
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                            </div>
                        </>}
                        {selectedType === 'month' &&
                            <>
                                <div className="inb-c-item inb-c-item--from row" key='slo'>
                                    {!locationsPending &&
                                        <>
                                            <div className="small-6 column">
                                                <div className="input-group inb-price-input-group">
                                                    <div className="float-left">
                                                        <label>{t('Standort')}</label>
                                                        <select defaultValue={selectedLocation} onChange={(e)=>{onChangeField(e,"location_field")}}>
                                                            <option value={null}>{t('switch')}</option>
                                                            {locations.map(location => {
                                                                return (<>
                                                                    <option value={location.id}>{location.name}</option>
                                                                </>)
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                </div>
                            </>
                        }

                        {!availableTimesPending  ?
                            <>
                            {availablesEnd && selectedTime !== null && <><div className="row">
                                    <div className="medium-12 column">
                                        <span style={{fontWeight:'bold'}}>Gewählte Zeit: {selectedTime}</span>
                                    </div>
                                </div></>}
                            {renderSwitch()}
                            {availablesEnd && <><br/>{renderSwitch(true)}</>}
                            </>: <>
                                <Loader
                                    mediumWidth={12}
                                    smallWidth={12}
                                    subLoaders={2}/>
                            </>}
                    </div>
                </Dialog>
            </>
        }
    </>);
};

export default AvailabilitiesView;